// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__Tygnz","circle-rotate":"Spinner_circle-rotate__einnb","dash":"Spinner_dash__0YFzs","circle-dash":"Spinner_circle-dash__GAZYL"};